import { back_office_axi, payment_axi } from "../context/authContext";

export const replenishPurchaseOrders = async (newData) => {
  try {
    await payment_axi.post("/api/payments/create-po", newData);
  } catch (error) {
    console.error("Error replenishing orders:", error);
    throw error;
  }
};

export const updateClient = async (newData) => {
  try {
    await back_office_axi.put(`/api/clients/update-client/${newData.client_id}`, newData);
  } catch (error) {
    throw error;
  }
};

